export default __webpack_public_path__ + "static/media/bgFeaturedMatchMb.003a1f52.png";